import { useWallet } from "@sundae/wallet-react";
import React, { lazy } from "react";

import ConnectWalletButton from "../ConnectWalletButton";

export interface IWalletButton {
  size?: "sm" | "lg";
}

const LazyWalletDetailsPopover = lazy(
  () => import(/* webpackChunkName: "WalletDetailsPopover" */ "../WalletDetailsPopover")
);

const WalletButton: React.FC<IWalletButton> = ({ size = "sm" }) => {
  const {
    state: { wallet },
  } = useWallet();
  const mainAddress = wallet?.mainAddress;

  if (Boolean(mainAddress)) {
    return <LazyWalletDetailsPopover address={mainAddress} size={size} />;
  }

  return <ConnectWalletButton className="ml-auto mr-auto lg:ml-0 lg:mr-0" />;
};

export default WalletButton;
